import ChipColors from '@/app/arch/enums/ChipColors';

export default [
  {
    text: 'Aguardando envio',
    value: 'Pending',
    ...ChipColors.wait,
  },
  {
    text: 'Rascunho',
    value: 'Draft',
    ...ChipColors.neutral,
  },
  {
    text: 'Agendado',
    value: 'Scheduled',
    ...ChipColors.wait,
  },
  {
    text: 'Enviado',
    value: 'Sent',
    ...ChipColors.success,
  },
  {
    text: 'Enviando',
    value: 'InProgess',
    ...ChipColors.light,
  },
];
